const AUTH_WALL_PAGES = ['/buyers/cc_onboarding'];

export const isPostAuthPageAccessed = (pathname: string): boolean => {
  return AUTH_WALL_PAGES.some((page) => pathname === page);
};
